var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBancontact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 16",
    width: 24,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.023c-1.784 2.37-3.938 5.023-8.034 5.023H1a1 1 0 0 1-1-1V8.023a1 1 0 0 1 1-1h12C14.784 4.653 16.94 2 21.034 2H26a1 1 0 0 1 1 1v5.023a1 1 0 0 1-1 1H14Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.966 13.046c3.767 0 5.65-2.512 7.534-5.023H1v5.023h4.966Z",
    fill: "url(#bancontact-a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.034 3c-3.767 0-5.65 2.511-7.534 5.023H26V3h-4.966Z",
    fill: "url(#bancontact-b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bancontact-a",
    x1: 3.528,
    y1: 10.766,
    x2: 12.673,
    y2: 7.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bancontact-b",
    x1: 14.257,
    y1: 8.458,
    x2: 23.966,
    y2: 5.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancontact);
export default __webpack_public_path__ + "static/media/bancontact.6e957fda975463a17f7b02af0c097b6e.svg";
export { ForwardRef as ReactComponent };